import { ColDef, GridApi, IFilter } from "@ag-grid-community/core";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { MatDateRangePicker, MatDatepicker } from "@angular/material/datepicker";
import { DatePipe } from "@angular/common";
import { SettingsService } from "src/app/services/settings.service";
import { Subject } from "rxjs";
import { debounceTime, filter, startWith, takeUntil } from "rxjs/operators";
import { HeaderService } from "src/app/components/header/header.service";
import { LoginModel } from "src/app/models/login.model";
import { SkuDetail } from "src/app/models/priceyard.model";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { AuthService } from "src/app/services/auth.service";
import { ShipmentVelocityComponent } from "src/app/components/shipment-velocity/shipment-velocity.component";
import { QuickFiltersComponent } from "src/app/components/quick-filters/quick-filters.component";
import { DatePickerModel } from "src/app/components/date-picker-dialog/date-picker.model";
import { GridActionsService } from "../grid-actions.service";
import { GridApiService } from "../grid-api.service";
import { SkuListItem } from "../../models/priceyard.model";
import { ColumnDropdownComponent } from "./../../components/column-dropdown/column-dropdown.component";
import { PlanyardService } from "./../../modules/planyard/planyard.service";
import { AnalyticsColumnDropdownComponent } from "src/app/components/analytics-column-dropdown/analytics-column-dropdown.component";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from "src/environments/environment";
import { ReportsService } from "src/app/services/reports.service";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import moment, { Moment } from "moment";
import { AnalyticsPlGridConfigService } from "../analytics-pl-grid-config.service";
import { FbmOrdersService } from "src/app/modules/fbm-orders/fbm-orders.service";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: "app-grid-wrapper-header",
  templateUrl: "./grid-wrapper-header.component.html",
  styleUrls: ["./grid-wrapper-header.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    DatePipe
  ],
})
export class GridWrapperHeaderComponent implements OnInit, OnDestroy,OnChanges {
  date = new FormControl(moment().subtract(1,'months'));
  range:FormGroup;
  searchInput: FormControl = new FormControl();
  selectedPlFilter:string = 'month';
  @Input() gridOptions;
  @Input() page:string;
  @Input() bulkType;
  @Input() hasSidebar: boolean;
  @Input() showActions: boolean;
  @Input() actions;
  @Input() datePickerLabel;
  isShowAccount: boolean = true;
  @Output() dateFilterOutput: EventEmitter<DatePickerModel> = new EventEmitter();
  @Output() accountFilterType: EventEmitter<any> = new EventEmitter();
  @Output() multipleDateFilter: EventEmitter<any> = new EventEmitter();
  @Output() groupByList: EventEmitter<any>= new EventEmitter();
  @Output() groupSkuList: EventEmitter<any>= new EventEmitter();
  @Output() dateChange: EventEmitter<any>= new EventEmitter();
  @Output() groupBySettlementList: EventEmitter<any>= new EventEmitter();
  @Output() viewByPlList: EventEmitter<any>= new EventEmitter();
  @Output() selectedDateRange: EventEmitter<any>= new EventEmitter();
  @Output() groupBysalesTrendList: EventEmitter<any>= new EventEmitter();
  @Output() selectedWarehouse: EventEmitter<any>=new EventEmitter();
  @Output() groupByDefaultList: EventEmitter<any>= new EventEmitter();
  @Input() defaultDateFilter: DatePickerModel;
  @Input() hideSearch: boolean;
  @Input() columnDefs;
  plFilter: FormControl=new FormControl('Monthly');
  allPl:any=['Monthly',"Quarterly","Weekly","Yearly",'Settlement'];
  gridApi: GridApi;
  userInfo: LoginModel;
  showDefaultColumn:boolean = true;
  isHideColumnChooser:boolean = false;
  isShow:boolean = false;
  private destroy$ = new Subject<void>();
  selectedSku: SkuDetail;
  selectedData;
  type:string;
  bulkTypeName: string;
  dateFilterButtonText: string;
  salesGridInput:FormControl = new FormControl('orders');
  warehouse:FormControl=new FormControl('all');
  defaultGridInput:FormControl = new FormControl('Sales');
  allAccounts: any=[];
  @Output() logisticSideBar: EventEmitter<any> = new EventEmitter();
  @ViewChild("picker") datePicker: MatDateRangePicker<Date>;
  private _openToolPanel: boolean;
  get openToolPanel(): boolean {
    return this._openToolPanel;
  }
  set openToolPanel(editPortal: boolean) {
    this._openToolPanel = editPortal;
    this.openPanel();
  }
  isMenuOpened: boolean = false;
  showDateFilter:boolean = false;
  skus: SkuListItem[];
  filterText: string;
  status: string;
  months:any = [
    {id:1,name:'January'},{id:2, name:'February' },{id:3,name:'March'},{id:4,name:'April'},{id:5,name:'May'},{id:6,name:'June'},
    {id:7,name:'July'},{id:8,name:'August'},{id:9,name:'September'},{id:10,name:'October'},{id:11,name:'November'},{id:12,name:'December'}
  ]
  allActions: any[] = [];
  gridTypeInput: FormControl = new FormControl('date');
  groupByFilter: FormControl = new FormControl('Date');
  groupProfitBySkuFilter: FormControl = new FormControl('Sku');
  accountFilter: FormControl = new FormControl('all');
  allMultipleSelectDate : any [] = ['1-7','1-30','30-60','60-90','90-180','180-365'];
  multipleDate: FormControl = new FormControl(this.allMultipleSelectDate);
  dateFilter: DatePickerModel = {
    from:  new Date(new Date().setDate(new Date().getDate() - 365)),
    to: new Date(),
  };
  filterInputValue:boolean=false;
  missingCogs:boolean=false;
  filterPoId;
  gridAcccountFilters=[]
  warehouses:any[]=[];

  constructor(
    public gridActionsService: GridActionsService,
    public shipyardService: ShipyardService,
    private planyardService: PlanyardService,
    public headerService: HeaderService,
    private authService: AuthService,
    private gridApiService: GridApiService,
    public router: Router,
    private dialog: MatDialog,
    private settingsService: SettingsService,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private reportService:ReportsService,
    private analyticsPlGridConfigService:AnalyticsPlGridConfigService,
    private fbmOrderService: FbmOrdersService
  ) {
    this.headerService.remoteActionBroadcaster.pipe(takeUntil(this.destroy$),
    filter((e) => e.action === "ExportSkuList"))
    .subscribe((e) => {
      const index= this.gridActionsService.exportSkusIds.findIndex(res=>res.id == e.id);
      if (e.response && e.response?.responseType !== "error" && index !== -1) {
        this.gridActionsService.exportSkusIds.splice(index,1);
        this.downloadSkus(e.response, true);
       } else if(e.response && e.response?.responseType == "error" && index !== -1){
        this.gridActionsService.exportSkusIds.splice(index,1);
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: e.response?.message, 
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.router.url == "/analytics/sales" || this.router.url == "/analytics/profit" || this.router.url == "/analytics/PpcSpent" || this.router.url == "/analytics/roi"){
      this.showDateFilter = true;
    }else{
      this.showDateFilter = false;
    }
  }

  bindAccountFilter(){
    this.gridAcccountFilters = JSON.parse(localStorage.getItem(StorageKeyEnum.AccountFilters)) || []; 
    const pageFilterIndex = this.gridAcccountFilters?.findIndex((filter)=>filter.page == this.page);
      if(pageFilterIndex == 0 || pageFilterIndex != -1){
        this.accountFilter.setValue(this.gridAcccountFilters[pageFilterIndex].account);
        this.accountFilterType.emit(this.gridAcccountFilters[pageFilterIndex].account)
      }
  }

  ngOnInit(): void {   
    this.shipyardService.selectedCellValue$.subscribe(value => {
      this.searchInput.setValue(value);
    });
    this.allAccounts = JSON.parse(localStorage.getItem(StorageKeyEnum.AllAccounts));

    if(this.page == 'inventory-summary'){
      MY_FORMATS.display.dateInput = "MM/YYYY"
    }else{
      MY_FORMATS.display.dateInput = "MM/DD/YYYY"
    }
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });
    this.range.get('start').setValue(this.dateFilter.from);
    this.range.get('end').setValue(this.dateFilter.to)
    if(this.page == 'sales-trends' && this.salesGridInput.value == 'orders'){
      this.isHideColumnChooser = true
    }
  this.accountFilter.valueChanges.subscribe(value=>{
    if(value){
      const pageFilterIndex = this.gridAcccountFilters?.findIndex((filter)=>filter.page == this.page);
      if((pageFilterIndex == 0 || pageFilterIndex != -1)){
        if(this.gridAcccountFilters[pageFilterIndex].account !== value){
          this.gridAcccountFilters[pageFilterIndex].account=value;
          localStorage.setItem(StorageKeyEnum.AccountFilters,JSON.stringify(this.gridAcccountFilters));
          this.gridActionsService.saveColumnStateWithJson(StorageKeyEnum.AccountFilters,this.gridAcccountFilters)
        }        
      } else{
        this.gridAcccountFilters.push({
          page:this.page,
          account:value
        })
        localStorage.setItem(StorageKeyEnum.AccountFilters,JSON.stringify(this.gridAcccountFilters));
        this.gridActionsService.saveColumnStateWithJson(StorageKeyEnum.AccountFilters,this.gridAcccountFilters)
      }
      this.accountFilterType.emit(value)
    }
  })
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => (this.userInfo = res));
    this.headerService.remoteActionBroadcaster
      .pipe(
        takeUntil(this.destroy$),
        filter((e) => e.action === "DownloadSkus")
      )
      .subscribe((e) => {
        if (this.gridApi) {
          this.gridApi.refreshServerSide({});
        }
      });
    this.gridApiService.gridApi$
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => {
        this.gridApi = e.api;
        this.initGlobalSearch();
        this.gridApi.showLoadingOverlay();
        this.filterText = this.getFbaTypeFilter();
        this.filterInputValue = this.getInputValueFilter();
        this.bindAccountFilter();
      });
    this.gridActionsService.isOpened = false;
    this.openToolPanel = localStorage.getItem("toolPanel")
      ? localStorage.getItem("toolPanel") == "true"
      : true;

      if (this.page == 'logistic' &&  this.openToolPanel)  this.clickLogisticSidebar(true);
    if (this.bulkType) {
      this.bulkTypeName = this.gridActionsService.mapBulkTypeToName(
        this.bulkType
      );
    }
    this.setVendorFilter(undefined);
    this.allActions = this.getActions();

    this.gridTypeInput.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if(value){
          this.groupBySettlementList.emit(value);
        } 
      });

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd),
        startWith(this.router)
      )
      .subscribe((event: NavigationEnd) => {
        const params = this.route.snapshot.params;
        if (params && params.reportType) {
          this.gridTypeInput.setValue(params.reportType, { emitEvent: false });
        }
      });
      this.gridActionsService.dateFilter$.next(this.defaultDateFilter);
      this.defaultGridInput.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
        if(value){
          this.groupByDefaultList.emit(value);
        } 
      });
      this.salesGridInput.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
        if(value){
         this.getMultipleSalesListDropdown(value);
         this.groupBysalesTrendList.emit(value);
         if(value !== 'orders'){
          this.showDefaultColumn = false;
          this.isHideColumnChooser = false;
         }else{
          this.showDefaultColumn = true;
          this.isHideColumnChooser = true;
         }
        } 
      });
      this.getWarehouse();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
    this.gridActionsService.globalSkuSearch$.next("");
    this.gridApiService.changedColumnState$.next(false);
    this.shipyardService.missingCogs=false;
  }

  getActions() {
    if(this.actions){
      return this.actions()
      .filter((res) => (res.hide ? !res.hide() : true))
      .filter((res) => {
        if (!res.permission) {
          return true;
        }
        return res.permission && this.userInfo[res.permission] ? true : false;
      });
    }
  }

  clearSearch() {
    this.searchInput.setValue("");
  }

  deSelectAll() {
    this.gridApi?.deselectAll();
    if (this.shipyardService.skusToAddToShipment.length) {
      this.shipyardService.shipmentTypeToAddToShipment$.next(undefined);
      this.shipyardService.skusToAddToShipment = [];
    }
  }

  initGlobalSearch() {
    this.searchInput.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(300)).subscribe((e) => {
        this.gridActionsService.globalSkuSearch$.next(e.trim());
        if (this.gridApi) {
          this.gridApi.refreshServerSide({ route: [], purge: true });
        }
      });
  }

  resetColumn() {
    this.gridActionsService.resetTable();
    this.gridApiService.changedColumnState$.next(false);
  }

  showGridWrapperActions() {
    this.isShow = !this.isShow;
  }

  setVendorFilter(vendorId,tag?) {
    this.planyardService.vendorId = vendorId;
    if (this.gridApi) {
      if(tag){
        this.gridApi.getFilterInstance("Tags")?.setModel({
          filterType: "set",
          values: [tag],
        });
        this.gridApi.onFilterChanged();
      } else 
      this.gridApi.refreshServerSide({ route: [], purge: true });
    }
  }

  filterReset(e: MouseEvent) {
    e.stopPropagation();
    if (this.page === "purchasing"|| this.page == 'purchase-by-sku') {
      this.setVendorFilter(undefined);
      this.filterText = "";
    } else if(this.page === 'replenish'){
      this.setReplenishFilter(undefined);
      this.filterText = "";
    }
  }

  getSelectedRowData() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length !== 0) {
      const selectedData = selectedNodes.map((node) => node.data);
      if (selectedData[0]) this.selectedData = selectedData[0];
    }
  }

  openPanel() {
    if (this.openToolPanel) {
      this.gridActionsService.isOpened = true;
      localStorage.setItem("toolPanel", "true");
      if(this.page=='shipyard'|| this.page=='replenish'){
        this.setToolPanelData();
      }
    } else {
      this.gridActionsService.closePanel();
      this.gridActionsService.isOpened = false;
      localStorage.setItem("toolPanel", "false");
    }
  }
  setToolPanelData(){
    const selectedRows = this.gridApi?.getSelectedRows();
    if (selectedRows?.length > 1) {
      this.gridActionsService.openSidePanel("multiSku");
      this.refreshMultiSkuPanel();
    } else {
      this.gridActionsService.openSidePanel("singleSku");
      this.refreshSingleSkuPanel();
    }
  }

  refreshSingleSkuPanel() {
    const singleToolpanelComponent = this.gridApi?.getToolPanelInstance('singleSku');
    if (singleToolpanelComponent) {
      singleToolpanelComponent.refresh(null);
    }
  }

  refreshMultiSkuPanel() {
    const multiToolpanelComponent = this.gridApi.getToolPanelInstance('multiSku');
    if (multiToolpanelComponent) {
      multiToolpanelComponent.refresh(null);
    }
  }

  clickLogisticSidebar(event) {
    this.logisticSideBar.emit(event);
  }

  menuOpened() {
    this.isMenuOpened = true;
    this.allActions = this.getActions();                  
  }

  menuClosed() {
    this.isMenuOpened = false;
  }

  openColumnChooser(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    let position,component,width;

    if(this.page !== 'profitBySkus'){
      component = ColumnDropdownComponent;
      width= this.page=='Stock-holding' ? "350px" : "200px";
      position= {
        left: this.page=='Stock-holding' ? targetPosision.right - 220 + "px" : targetPosision.right - 200 + "px" ,
        top: targetPosision.top + 30 + "px",
      };
    } else{
      component = AnalyticsColumnDropdownComponent;
      width="1127px";
      position= {
        left: targetPosision.right - 1127 + "px",
        top: targetPosision.top + 50 + "px",
      }
    }
    
    this.dialog.open(component, {
      width: width,
      position: position,
      data: {
        gridOptions :this.gridApi,
        isTrendSales : this.page == 'sales-trends' ? true : false,
        columnDefs: this.columnDefs
      }, 
      backdropClass: "column-dialog",
    });
  }

  openSettingDialog(e: MouseEvent) {
    const dialog = this.dialog.open(ShipmentVelocityComponent, {
      width: "250px",
      position: this.getDialogPosition(e),
      backdropClass: "column-dialog",
      data: {
        page: this.page,
      },
    });

    dialog.afterClosed().subscribe((e) => {
      if (e === "Save") {
        if (this.page === "replenish") {
          const columnDefs: ColDef[] = this.gridApi.getColumnDefs();

          this.settingsService
            .GetSettings(["replenishnostock"]).pipe(takeUntil(this.destroy$))
            .subscribe((res: any[]) => {
              if (res) {
                const replenishnostock = res.find(
                  (x) => x.name === "replenishnostock"
                );

                const RemainingNullLastIndex = columnDefs.findIndex(
                  (x) => x.field === "RemainingNullLast"
                );
                const RestockIndex = columnDefs.findIndex(
                  (x) => x.field === "Restock"
                );
                if (replenishnostock.isOn) {
                  this.gridApi.destroyFilter("LocalMinusReserved");
                  columnDefs[RestockIndex].sort = "desc";
                  columnDefs[RemainingNullLastIndex].sort = null;
                } else {
                  columnDefs[RemainingNullLastIndex].sort = "asc";
                  columnDefs[RestockIndex].sort = null;
                  this.setLocalStockFilter(columnDefs);
                }
              }

              this.gridApi.setGridOption('columnDefs', columnDefs);
              this.gridApi.refreshServerSide({ route: [], purge: true });
            });
        } else {
          this.gridApi.refreshServerSide({ route: [], purge: true });
        }
      }
    });
  }

  openFiltersDialog(e: MouseEvent) {
    const dialog = this.dialog.open(QuickFiltersComponent, {
      width: "300px",
      position: this.getDialogPosition(e),
      backdropClass: "column-dialog",
      data: {
        filterType: this.page,
        currentValue: this.filterText,
        filterInputValue:this.filterInputValue,
        status: this.status
      },
    });

    dialog.afterClosed().subscribe((e) => {
      if (e?.fbaType) {
        this.filterText = e.fbaType;

        this.gridApi.setFilterModel({
          FbaType: {
            filterType: "set",
            values: [e.fbaType],
          },
        });
      } else if ((e?.vendor && e?.vendor?.name) || e?.tag) {
        this.filterText = e.vendor.name;
        this.setVendorFilter(e.vendor.vendorId,e.tag);
      }  else if (this.page == 'replenish') {
        this.filterInputValue = e.queuedSku;  
        if(e?.replenishwarehouse && e?.replenishwarehouse?.warehouseId){
          this.filterText = e.replenishwarehouse.name;
        //  this.setInputFilter(this.filterInputValue);
          this.setReplenishFilter(e.replenishwarehouse.warehouseId);
        }else if(e.replenishnostock){
          this.gridApi.getFilterInstance("LocalMinusReserved")?.setModel({
            type: "greaterThan",
            filter: '0',
          });
          this.gridApi.onFilterChanged();
        } else{    
          this.gridApi.destroyFilter("LocalMinusReserved");     
          if (this.gridApi) {
        //    this.setInputFilter(this.filterInputValue);
            this.gridApi.refreshServerSide({ route: [], purge: true });
          }
        }
      }
      if (e?.status) {
        this.status = e.status;
        if (this.status === "All") {
          this.gridOptions.api
            .getFilterInstance("StockNote")
            .getChildFilterInstance(1)
            .setModel();
        } else {
          this.gridOptions.api
            .getFilterInstance("StockNote")
            .getChildFilterInstance(1)
            .setModel({
              filterType: "set",
              values: [e.status],
            });
        }
        this.gridApi.onFilterChanged();
      }
    });
  }

  getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 260 + "px",
      top: targetPosision.top + 20 + "px",
    };
  }


  getFbaTypeFilter() {
    if (this.gridApi && this.gridApi.getFilterModel().FbaType) {
      const values = this.gridApi.getFilterModel().FbaType.values;
      if (values.length) {
        return values[0];
      }
    }
  }

  dateFilterChange(date){
    this.gridActionsService.dateFilter$.next(date.selectedDate);
    this.dateFilterOutput.emit(date);
  }

  async downloadBlob(url,name = "sku-list-download.csv",isUrlIncluded = false) {
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        horizontalPosition: 'center',
        data: {
          title: 'Sku list preparing download...', 
          action: 'Dismiss',
          type: 'info',
        },
      }
    );
  const outsideRes = await fetch(isUrlIncluded ? url.message : environment.apiUrl + url.message);
  const blob = (await outsideRes).blob();
  const blobUrl = window.URL.createObjectURL(await blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = name;
   link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    this.snackBar.dismiss();
    this.snackBar.openFromComponent(SnackbarComponent,
      {
        duration: 3000,
        horizontalPosition: 'center',
        data: {
          title: 'Sku list downloaded successfully.', 
          action: 'Dismiss',
          type: 'success',
        },
      }
    );
    document.body?.removeChild(link);
  }

  downloadSkus(url, isUrlIncluded = false) {
    this.downloadBlob(url,"sku-list-download.CSV",isUrlIncluded);     
  }
  
  onChange(event){
    this.gridActionsService.productGroupbyFilter=event.target.value;
    this.groupByList.emit(event.target.value);
  }

  setReplenishFilter(warehouseId){
    this.shipyardService.warehouseId = warehouseId;
    const columnDefs: ColDef[] = this.gridApi.getColumnDefs();    
    this.setLocalStockFilter(columnDefs);
    if(!warehouseId){
      this.resetSetting();
    } else{
      if (this.gridApi) {
        this.gridApi.refreshServerSide({ route: [], purge: true });
      }
    }
  }

  setLocalStockFilter(columnDefs){
    if (this.userInfo && this.userInfo.isPlanYard === 1) {
      if(this.shipyardService.warehouseId){
        const localMinusReservedIdx = columnDefs.findIndex(
          (x) => x.field === "LocalMinusReserved"
        );
        if(localMinusReservedIdx != -1) {
          columnDefs[localMinusReservedIdx].colId = "WarehouseLocalStock";
          columnDefs[localMinusReservedIdx].field = "WarehouseLocalStock";
        }
        this.gridApi.setGridOption('columnDefs', columnDefs);
        this.gridApi.getFilterInstance("WarehouseLocalStock")?.setModel({
          type: "greaterThan",
          filter: '0',
        });
      } else{
        const warehouseLocalStockIdx = columnDefs.findIndex(
          (x) => x.field === "WarehouseLocalStock"
        );
        if(warehouseLocalStockIdx != -1) {
          columnDefs[warehouseLocalStockIdx].colId = "LocalMinusReserved";
          columnDefs[warehouseLocalStockIdx].field = "LocalMinusReserved";
        }
        this.gridApi.setGridOption('columnDefs', columnDefs);
        this.gridApi.getFilterInstance("LocalMinusReserved")?.setModel({
          type: "greaterThan",
          filter: '0',
        });
      } 
      this.gridApi.onFilterChanged();
    }
  }

  resetSetting() {
      const payload = [
        {
          name: 'replenishwarehouse',
          str1: ""
        }
      ];
      this.settingsService.SaveSettings(payload).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          if (res) {
            if (this.gridApi) {
              this.gridApi.refreshServerSide({ route: [], purge: true });
            }
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Warehouse setting reset successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            );
          }
        },
        error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent,{
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Something went wrong',
              action: 'Dismiss',
                type: 'error',
            },
          })
        }
       });
  }
  onDateChange($event){
    this.dateChange.emit($event);
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }
  
  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);    
    this.setDate(this.date.value.toDate());
     datepicker.close();
  }
  
  setDate(date:any){
    let selectedMonth
    const monthName = this.date.value.format('MMMM');
    const selectedYear = date.getFullYear();
      let index = this.months.findIndex((el) => el.name == monthName);
      if(index !== -1){
        selectedMonth = this.months[index].id;
      }
      this.reportService.selectedFilter = {
        month : Number(selectedMonth),
        year:Number(selectedYear)
      }
      if (this.gridApi && selectedYear && selectedMonth) {
        this.gridApi.refreshServerSide({ route: [], purge: true });
      }
   }
   
  multipleDateChnages(selectDate){
   let res =  selectDate.value;
    if(res){
      let  date = [];
      const keys = Object.keys(res);
      keys.forEach((result)=>{
        date.push({
          label: res[result],
         })})
       this.multipleDateFilter.emit(date);
     }
  }
  onProfitBySkuChange(event){
    if (event.target.value === "Product") {
      this.isShowAccount = false;
    } else {
      this.isShowAccount = true;
    }
    this.groupSkuList.emit(event.target.value);
  }

  getInputValueFilter() {
    if (this.gridApi && this.gridApi.getFilterModel().QueueQty) {
      const values = this.gridApi.getFilterModel().QueueQty.values;
      if (values.length) {
        return values[0];
      }
    }
  }

  setInputFilter(isFilter=false){ 
    const filterInstance: IFilter = this.gridApi.getFilterInstance("QueueQty");
    if(isFilter){
      filterInstance?.setModel({
        filter: 0,
        filterType: "number",
        type: "greaterThan"
      });
      this.gridApi?.onFilterChanged();
    } else{
      filterInstance?.setModel(null);
      this.gridApi?.onFilterChanged();
    }
  }
  
  plFilterChange(event){
    switch (event.target.value) {
      case 'Monthly':          
      this.selectedPlFilter = 'month'
      break;            
      case 'Quarterly':
        this.selectedPlFilter = 'quarter'
      break;
      case 'Weekly': 
      this.selectedPlFilter = 'week'
      break;
      case 'Yearly':  
      this.selectedPlFilter ='year'       
      break;
      case 'Settlement':  
      this.selectedPlFilter ='settlement'       
      break
      } 
    this.viewByPlList.emit(this.selectedPlFilter);
  }

  getMultipleSalesListDropdown(value){
    if(value == 'qty'){
      this.allMultipleSelectDate = [];
      this.allMultipleSelectDate = ['Revenue','Orders','Returns'],
      this.multipleDate.setValue(this.allMultipleSelectDate);
    }else if(value == 'columns'){
      this.allMultipleSelectDate = [];
      this.allMultipleSelectDate = ['1-7','1-30','30-60','60-90','90-180','180-365'],
      this.multipleDate.setValue(this.allMultipleSelectDate);
    }
  }

  getDateRange(dateRangeStart,dateRangeEnd){
    const [month,day,year] = dateRangeStart.value.split('/');  
    const [endMonth,endDay, endYear] = dateRangeEnd.value.split('/');
    if(dateRangeEnd.value){
      const date = {
        dateFrom: new Date(+year,+month - 1, +day),
        dateTo:new Date(+endYear, +endMonth - 1, +endDay)
      }
      this.selectedDateRange.emit(date);
    }
  }

  setPlDateRange(viewByPlValue){
    this.analyticsPlGridConfigService.setPlDateRange(viewByPlValue);
    this.range.get('start').setValue(this.analyticsPlGridConfigService.dateFilter.from);
    this.range.get('end').setValue(this.analyticsPlGridConfigService.dateFilter.to)
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  toggleCogs(){
    this.missingCogs=!this.missingCogs;
      const filterInstance: IFilter = this.gridApi.getFilterInstance("SkuPrep");
      const filterInstance1: IFilter = this.gridApi.getFilterInstance("SkuCost");
      if(filterInstance && filterInstance1 && this.missingCogs){
        filterInstance?.setModel({ filterType: "number",type: "blank" });
        filterInstance1?.setModel({filterType: "number", type: "blank" });
        this.gridApi.onFilterChanged();
       } else{
         filterInstance?.setModel(null);
         filterInstance1?.setModel(null);
         this.gridApi?.onFilterChanged();
       }
    this.shipyardService.missingCogs = this.missingCogs;   
      if (this.gridApi) {
        this.gridApi.refreshServerSide({ route: [], purge: true });
      }
  }

  openFilterPoId(e){
    const dialog = this.dialog.open(ShipmentVelocityComponent, {
      width: "250px",
      position: this.getDialogPosition(e),
      backdropClass: "column-dialog",
      data: {
        page: this.page,
        isPoFilter: true,
        currentValue:this.filterPoId || ""
      },
    });
    dialog.afterClosed().subscribe((e) => {
      if(e){
        this.filterPoId=e.filterPoId;
        if (e.skus?.length) {
          this.shipyardService.skuFilterSet = e.skus; 
          this.gridApi.refreshServerSide({ route: [], purge: true });
        }
      }
    });
  }

  filterPoIdReset(e){
    e.stopPropagation();    
    this.filterPoId = "";
    this.shipyardService.skuFilterSet = null; 
    this.gridApi.refreshServerSide({ route: [], purge: true });
  }

  getWarehouse() {
    this.settingsService
      .GetAllWarehouses()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any[]) => {
        this.warehouses = res;
      });
  }

  onWarehouseChange(e) {
    this.selectedWarehouse.emit(e.target.value);
  }
}
